import { render } from "./ShopBranches.vue?vue&type=template&id=7003d204&scoped=true"
import script from "./ShopBranches.vue?vue&type=script&lang=js"
export * from "./ShopBranches.vue?vue&type=script&lang=js"

import "./ShopBranches.vue?vue&type=style&index=0&id=7003d204&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7003d204"]])

export default __exports__